import environment from '~/platform/utilities/environment';

export const SUBMIT_URL = `${
  environment.API_URL
}/v0/education_benefits_claims/10272`;

export const TITLE =
  'Request licensing or certification test prep course fees reimbursement online';
export const SUBTITLE =
  'Request for Reimbursement of a Preparatory Course for a Licensing or Certification Test (VA Form 22-10272)';
